import type { GenericObject, PaymentWithDealerIdRequest } from '@makemydeal/dr-platform-types';
import { TRACE_ID_HEADER } from '@makemydeal/dr-shared-bff-types';

export type FetchPaymentResult = {
    result?: GenericObject;
    error?: GenericObject;
};

export const ABORT_ERROR_MESSAGE = 'Request aborted';

export const isRequestAborted = (message: string): boolean => {
    return message === ABORT_ERROR_MESSAGE;
};

export const toFetchPaymentError = (error: any): FetchPaymentResult => {
    if (error?.name === 'AbortError') {
        return {
            error: {
                message: ABORT_ERROR_MESSAGE
            }
        };
    }

    return {
        error: {
            message: error?.message
        }
    };
};

export const fetchPayments = async (
    paymentUrl: string,
    payload: PaymentWithDealerIdRequest,
    abortSignal?: AbortSignal
): Promise<FetchPaymentResult> => {
    const opts = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            [TRACE_ID_HEADER]: payload.traceId ?? ''
        },
        signal: abortSignal
    };

    try {
        // Returns a custom-type data-object as result which is transformed into 'TransformedOfferPaymentData' by various functions defined in paymentPayLoadUtils.ts
        const first = await fetch(paymentUrl, opts);
        const result = (await first.json()) as GenericObject;
        if (first.status >= 400) {
            return {
                error: result
            };
        }
        return {
            result
        };
    } catch (error: any) {
        return toFetchPaymentError(error);
    }
};
